import { useTranslation } from "react-i18next";
import { FaGlobe } from "react-icons/fa";

import type { FC } from "react";

const U2000Footer: FC = () => {
  const { i18n, t } = useTranslation();

  const nextLang: string = i18n.language === "fr" ? "en" : "fr";
  const handleChangeLanguage = (): void => {
    i18n.changeLanguage(nextLang);
  };

  const currentLangDisplay = i18n.language === "fr" ? "Français" : "English";

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto flex justify-between items-center px-4 py-3">
      <div className="flex items-center text-sm text-gray-600">
        <span>{t("lblAllRightsReserved")}</span>
      </div>

      <div className="flex items-center gap-4">
        <button onClick={handleChangeLanguage} className="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded-lg transition-colors">
          <FaGlobe className="w-4 h-4" />
          <span>{currentLangDisplay}</span>
        </button>
      </div>
    </footer>
  );
};

export default U2000Footer;
